import { Space, Row, Col, Button, Popover } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { ColumnPopoverDisplay, ModalCustom } from "components/common";
import Icons from "assets/icons";
import { allColumns as columnsInit } from "./WorkHistory.config";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getLichSuCongTac } from "redux/reducer/employee";

import {
  saveTableOptions,
  getTableOptions,
} from "../../../../../../helper/common";
import { ColumnProps } from "../../../../../../types/models";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import FormAdd from "./FormWork/FormWork";
import FormWork from "./FormWork/FormWork";

const WorkHistory = () => {
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const dispatch = useAppDispatch();
  let idEmp = useAppSelector((state) => state.employeesReducer.idEmp);
  const employeesStore = useAppSelector((state) => state.employeesReducer);
  const employeeId = employeesStore?.employee?.maNhanVien;
  let status = useAppSelector((state) => state.employeesReducer.status);
  const modalRef = useRef<any>();
  const [loading, setLoading] = useState(false);
  let savedTableOption = getTableOptions(
    "LICENSE_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? columnsInit.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : columnsInit;
  const [columns, setColumns] = useState<ColumnProps[]>(
    defaultColumns.filter((e) => e.show === true)
  );
  columns.map((e) => {
    if (e.key == "index") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 100,
  });
  const [refreshList, setRefreshList] = useState<boolean>(false);

  useEffect(() => {
    if (employeeId) getListLSCT({ ...params, ma_nhan_vien: employeeId });
  }, [employeeId, refreshList]);

  const getListLSCT = async (params) => {
    setLoading(true);

    await dispatch(getLichSuCongTac(params));
    setLoading(false);
  };
  // useEffect(() => {
  //   const newColumns = columns;
  //   columns.find((e) => e.dataIndex == "action").render = (
  //     value,
  //     _record,
  //     index
  //   ) => {
  //     return (
  //       <ListActionButton
  //         deleteFunction={() => {
  //           deleteLicense(_record.id);
  //         }}
  //         editFunction={() => {
  //           setType("Sửa");
  //           setRecord(_record);
  //           modalRef.current?.openModal();
  //         }}
  //       ></ListActionButton>
  //     );
  //   };
  //   setColumns(newColumns);
  // }, []);

  useEffect(() => {
    setLoading(true);
    // if (employeesStore.listLSCT?.length) {
    //   setData(employeesStore.listLSCT);
    // }
    setData(employeesStore.listLSCT);
    setLoading(false);
  }, [employeesStore.listLSCT,employeeId]);

  const onChangePagination = (page, pageSize) => {
    setParams({ ...params, page: page, limit: pageSize });
  };

  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };
  const setShowColumnsList = (showColumns) => {
    saveTableOptions(
      "LICENSE_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  return (
    <div className="medicine-container">
      <div className="container">
        <Space style={{ width: "100%" }} direction="vertical">
          <Row justify={"space-between"} gutter={[16, 8]}>
            <Col>
              <Popover
                trigger="click"
                placement="topLeft"
                content={
                  <ColumnPopoverDisplay
                    setShowColumns={setShowColumns}
                    columns={columns}
                  ></ColumnPopoverDisplay>
                }
              >
                <Button
                  icon={<Icons.bars rev={0} />}
                  className="btn-sub"
                  type="ghost"
                >
                  Cột hiển thị
                </Button>
              </Popover>
            </Col>
            <Col>
              <Space style={{ width: "100%" }}>
                {/* <Button
                  className="custom-btn"
                  icon={<ExcelSVG />}
                  onClick={() => handleExportExcel(idEmp)}
                >
                  <Typography>Xuất báo cáo</Typography>
                </Button> */}

                <Button
                  type="primary"
                  onClick={() => {
                    setType("Thêm");
                    setRecord(null);
                    modalRef.current?.openModal();
                  }}
                >
                  Thêm mới
                </Button>
              </Space>
            </Col>
          </Row>
          {data && (
            <CustomResizableTable
              pagination={{
                position: ["bottomRight"],
                showSizeChanger: true,

                onChange: onChangePagination,
              }}
              setShowColumns={setShowColumnsList}
              columns={columns}
              dataSource={data}
              bordered={true}
              loading={loading}
              scroll={{ x: 900 }}
            />
          )}
          <ModalCustom
            ref={modalRef}
            width={1400}
            title={`${type} mới lịch sử công tác`}
          >
            <FormWork
              data={record}
              getListApi={() => setRefreshList(!refreshList)}
              type={type}
              idEmp={idEmp}
              setCurrentPage={null}
            ></FormWork>
          </ModalCustom>
        </Space>
      </div>
    </div>
  );
};

export default WorkHistory;
